export default __webpack_public_path__ + "static/media/ok-sm.657ddeff.svg";